// extracted by mini-css-extract-plugin
export default {"setUpTwoFA__card":"y53vkrDKkS","setUpTwoFA__card__split":"dcmElSUsM8","setUpTwoFA__button":"y4I_uo3Ujp"};